// Module
var code = `<form class="new-loan-parameters" name="\$ctrl.formParam" novalidate>
    <div class="alert-container">
      <div class="alert alert--danger" ng-if="\$ctrl.warningMessage">
        {{\$ctrl.warningMessage}}
        <button type="button" class="close" ng-click="\$ctrl.closeWarning()">&times;</button>
      </div>
    </div>

    <div ng-if="\$ctrl.loan.forcedRenewal" class="alert alert--danger">
      {{ \$ctrl.forcedRenewalMessage }}
    </div>

    <div class="info">
      <div class="info__field">
        <span class="key">Product Name:</span>
        <span class="value">{{\$ctrl.loanProduct.productDefinition.productName}}</span>
      </div>
      <div class="info__field">
        <span class="key">Min interest rate:</span>
        <!--TODO-->
        <span class="value">{{\$ctrl.loanProduct.minInterestRate}}%</span>
      </div>
      <div class="info__field">
        <span class="key">Max interest rate:</span>
        <span class="value">{{\$ctrl.loanProduct.maxInterestRate}}%</span>
      </div>
    </div>

    <h2 ng-if="\$ctrl.isEditModeEnabled()" class="section-header">Please confirm the following:</h2>
    <div class="entry-form">
      <table class="table">
        <tbody class="tbody">
        <tr  permissions="CST_CREDIT_LINE_READ" ng-if="!\$ctrl.groupLoan">
          <td class="label">Avail credit line?</td>
          <td class="values">
            <select
                    boolean-options
                    ng-model="\$ctrl.availCreditLine"
                    ng-required="true"
                    ng-disabled="!\$ctrl.isEditModeEnabled()"
                    ng-change="\$ctrl.clearCreditLineIdIfDisabledAndUpdateMaxAmount()"></select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.cycle !== null && \$ctrl.cycle !== undefined">
          <td class="label">Loan cycle including this loan</td>
          <td class="values">
            <input type="text" value="{{\$ctrl.cycle + 1}}" disabled>
          </td>
        </tr>
        <tr permissions="CST_CREDIT_LINE_READ" ng-if="\$ctrl.availCreditLine" >
          <td class="label">Select credit line</td>
          <td class="values">
            <select
                    ng-model="\$ctrl.loan.creditLineId"
                    ng-options="entry.id as entry.selectDisplay for entry in \$ctrl.availableCreditLines"
                    ng-required="true"
                    ng-disabled="!\$ctrl.isEditModeEnabled()"
                    ng-change="\$ctrl.updateLoanMaxAmount()"></select>
            <help title="Only credit lines with sufficient unused amount are displayed" ></help>
          </td>
        </tr>
        <tr ng-if="!\$ctrl.groupLoan">
          <td class="label">Creation Type</td>
          <td class="values">
            <select
                    ng-model="\$ctrl.loan.creationType"
                    ng-options="entry.value as entry.label for entry in \$ctrl.creationTypes"
                    ng-required="true"
                    ng-disabled="!\$ctrl.isEditModeEnabled()"></select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.isLoanRestructure() || \$ctrl.isLoanReconstruction() || \$ctrl.isLoanRenewal()">
          <td class="label" ng-if="\$ctrl.isLoanRestructure()">Restructured from</td>
          <td class="label" ng-if="\$ctrl.isLoanReconstruction()">Reconstructed from</td>
          <td class="label" ng-if="\$ctrl.isLoanRenewal()">Renewed from</td>
          <td class="values">
            <input disabled
                   type="text"
                   ng-model="\$ctrl.loan.sourceLoan.productNumber"/>
          </td>
        </tr>

        <tr ng-if="\$ctrl.isLoanRenewal()">
          <td class="label">Renewed loan principal balance</td>
          <td class="values">
            <cash
              class="value"
              ng-disabled="true"
              ng-model="\$ctrl.loan.sourceLoan.principalBalance"
              hide-currency="true"
            >
            </cash>
          </td>
        </tr>


        <tr ng-if="\$ctrl.isLoanRenewal()">
          <td class="label">Total balance (with interest and fees)</td>
          <td class="values">
            <cash
              class="value"
              ng-disabled="true"
              ng-model="\$ctrl.renewedLoanDetails.remainingBalanceWithFees"
              hide-currency="true"
            >
            </cash>
          </td>
        </tr>

        <tr ng-if="\$ctrl.isLoanRenewal()">
          <td class="label">Paid principal</td>
          <td class="values">
            <cash
              class="value"
              ng-disabled="true"
              ng-model="\$ctrl.renewedLoanDetails.paidPrincipal"
              hide-currency="true"
            >
            </cash>
          </td>
        </tr>

        <tr ng-if="\$ctrl.isLoanRenewal()">
          <td class="label">Required paid principal</td>
          <td class="values">
            <cash
              class="value"
              ng-disabled="true"
              ng-model="\$ctrl.renewedLoanDetails.requiredPaidPrincipal"
              hide-currency="true"
            >
            </cash>
            <help ng-if="\$ctrl.loan.forcedRenewal"
                  title="Overriden by forced renewal">
          </td>
        </tr>

        <tr ng-if="!\$ctrl.groupLoan">
          <td class="label">Principal</td>
          <td class="values">
            <cash class="row-info-section"
                  prepend="'min.'"
                  ng-disabled="true"
                  ng-model="\$ctrl.minAmount"></cash>
            <cash
              class="value"
              ng-required="true"
              ng-disabled="!\$ctrl.isEditModeEnabled() || \$ctrl.isLoanReconstruction()"
              ng-model="\$ctrl.loan.principalAmount"
              min="\$ctrl.minAmount"
              max="\$ctrl.maxAmount"
              hide-currency="true"
            ></cash>
            <cash class="row-info-section" prepend="'max.'"
                  value="\$ctrl.maxAmount"
                  ng-disabled="true"></cash>
            <button type="button"
                    class="btn btn-default btn-suggest-principal"
                    ng-if="\$ctrl.isLoanRestructure() || \$ctrl.isLoanConsolidation()"
                    ng-disabled="\$ctrl.suggestPrincipalDisabled()"
                    ng-click="\$ctrl.suggestPrincipal()">
              Suggest principal
            </button>
            <help ng-if="\$ctrl.isLoanReconstruction()" title="Use Suggest Principal after specifying the waive amount and loan parameters to calculate the principal amount. The release amount of the reconstructed loan must be equal to the previous loan's outstanding balance."></help>
          </td>
        </tr>
        <tr>
          <td class="label" ng-if="(\$ctrl.loan.interestType || \$ctrl.loanProduct.interestType) !== 'ADD_ON_RATE'">Interest rate</td>
          <td class="label" ng-if="(\$ctrl.loan.interestType || \$ctrl.loanProduct.interestType) === 'ADD_ON_RATE'">Interest rate (monthly add-on)</td>
          <td class="values">
            <div class="row-info-section">
              <glue-container prepend="'min.'" append-percentage="true">
                <input disabled
                       type="number"
                       ng-model="\$ctrl.loanProduct.minInterestRate"/>
              </glue-container>
            </div>

            <input type="number" class="value"
                   name="interestRate"
                   ng-required="!\$ctr.loanProduct.useInterestRateBoard"
                   ng-model="\$ctrl.loan.interestRate"
                   ng-disabled="!\$ctrl.canInputInterestRate()"
                   min="{{\$ctrl.loanProduct.minInterestRate}}"
                   max="{{\$ctrl.loanProduct.maxInterestRate}}"
                   ng-change="\$ctrl.updatePastDueInterestRates()"
                   step="0.00001">

            <div class="row-info-section">
              <glue-container prepend="'max.'" append-percentage="true">
                <input disabled
                       type="number"
                       ng-model="\$ctrl.loanProduct.maxInterestRate"/>
              </glue-container>
            </div>
          </td>
        </tr>
        <tr ng-if="!\$ctrl.groupLoan">
          <td class="label">Loan Officer</td>
          <td>
            <user-select
              hide-role="true"
              empty-option="true"
              ng-model="\$ctrl.loan.officerId"
              ng-disabled="!\$ctrl.isEditModeEnabled()"
              users="\$ctrl.officers">
            </user-select>
          </td>
        </tr>
        <tr ng-if="!\$ctrl.groupLoan">
          <td class="label">Loan Collector</td>
          <td>
            <user-select
              hide-role="true"
              empty-option="true"
              ng-model="\$ctrl.loan.collectorId"
              ng-disabled="!\$ctrl.isEditModeEnabled()"
              users="\$ctrl.collectors">
            </user-select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.loanProduct.withLinkedDepositAccount">
          <td class="label">Linked deposit account:</td>
          <td class="values">
            <select ng-model="\$ctrl.loan.linkedDepositAccountId"
                    required
                    ng-options="entry.id as entry.label for entry in \$ctrl.linkedDepositAccounts">
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">Payment interval</td>
          <td>
            <select
                    ng-model="\$ctrl.loan.paymentIntervalDefinitionId"
                    ng-options="o.id as o.name for o in \$ctrl.paymentIntervals"
                    ng-change="\$ctrl.interestCalculationParamsChanged()"
                    required
                    ng-disabled="!\$ctrl.isEditModeEnabled()"></select>
          </td>
        </tr>
        <tr>
          <td class="label">Total amortization number</td>
          <td>
            <input ng-disabled="!\$ctrl.isEditModeEnabled() || \$ctrl.loan.paymentIntervalDefinition.paymentIntervalType === 'SINGLE_PAYMENT'"
                   type="number"
                   required
                   min="{{\$ctrl.isLoanRestructure() ? \$ctrl.minRestructuredAmortizations : 1}}"
                   max="2000"
                   ng-change="\$ctrl.interestCalculationParamsChanged()"
                   ng-model="\$ctrl.loan.totalAmortizationNumber">
          </td>
        </tr>
        <tr ng-if="\$ctrl.balloonDiminishingAmortizationTypes.includes(\$ctrl.loanProduct.amortizationType)">
          <td class="label">Diminishing amortization number</td>
          <td>
            <input type="number"
                   class="value"
                   required
                   min="1"
                   max="{{\$ctrl.loan.totalAmortizationNumber - 1}}"
                   ng-model="\$ctrl.loan.diminishingAmortizationNumber"
                   ng-disabled="!\$ctrl.isEditModeEnabled()"/>
          </td>
        </tr>
        <tr ng-if="\$ctrl.loanProduct.collectAdvanceInterest">
          <td class="label">Advance interest no.</td>

          <td class="values">
            <div class="row-info-section">
              <glue-container prepend="'min.'" append="'no'" class="margin-bottom">
                <input type="number"
                       value="0"
                       disabled />
              </glue-container>
            </div>

            <input type="number"
                   class="value"
                   required
                   min="0"
                   ng-max="\$ctrl.getAdvanceInterestMaxNo()"
                   ng-model="\$ctrl.loan.advanceInterestNo"
                   ng-disabled="!\$ctrl.isEditModeEnabled()" />

            <div class="row-info-section">
              <glue-container prepend="'max.'" append="'no'" class="margin-bottom">
                <input type="number"
                       ng-value="\$ctrl.getAdvanceInterestMaxNo()"
                       disabled/>
              </glue-container>
            </div>

          </td>
        </tr>
        <tr ng-if="\$ctrl.loanProduct.collectAdvanceInterest">
          <td class="label">Advance interest application</td>
          <td>
            <select
                    ng-model="\$ctrl.loan.advanceInterestApplication"
                    ng-options="a.value as a.label for a in \$ctrl.advanceInterestApplicationTypes"
                    ng-disabled="!\$ctrl.isEditModeEnabled()"
                    required>
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.loanProduct.amortizationType == 'DIMINISHING_EQUAL_AMORTIZATION'
          || \$ctrl.loanProduct.amortizationType == 'DIMINISHING_EQUAL_AMORTIZATION_EXACT_DAYS'">
          <td class="label">Override amortization amount</td>
          <td>
            <input type="number"
                   min="0"
                   ng-model="\$ctrl.loan.overrideAmortizationAmount"
                   ng-disabled="!\$ctrl.isEditModeEnabled()">
          </td>
        </tr>
        <tr ng-if="\$ctrl.balloonCyclicAmortizationTypes.includes(\$ctrl.loanProduct.amortizationType)">
          <td class="label">Apply principal every</td>
          <td>
            <glue-container append="'amortizations'">
              <input type="number"
                     ng-model="\$ctrl.loan.interestCalculationParameter"
                     required
                     ng-disabled="!\$ctrl.isEditModeEnabled()"
                     min="1" max="365">
            </glue-container>
          </td>
        </tr>
        <tr ng-if="['BALLOON_SPREAD'].includes(\$ctrl.loanProduct.amortizationType)">
          <td class="label">Spread percentage</td>
          <td>
            <glue-container append-percentage="true">
              <input type="number"
                     ng-model="\$ctrl.loan.interestCalculationParameter"
                     ng-disabled="!\$ctrl.isEditModeEnabled()"
                     required
                     min="1" max="100">
            </glue-container>
          </td>
        </tr>
        <tr ng-if="\$ctrl.loan.paymentIntervalDefinition.paymentIntervalType === 'SINGLE_PAYMENT'">
          <td class="label">Term</td>
          <td class="values">
            <div class="row-info-section">
              <glue-container prepend="'min.'" append="'days'">
                <input disabled
                       type="number"
                       ng-model="\$ctrl.loanProduct.minTerm"/>
              </glue-container>
            </div>

            <div class="row-info-section">
              <input required type="number" class="value"
                     ng-disabled="!\$ctrl.isEditModeEnabled()"
                     ng-model="\$ctrl.loan.term"
                     ng-change="\$ctrl.calculateFirstPaymentDate()"
                     min="{{\$ctrl.loanProduct.minTerm}}"
                     max="{{\$ctrl.loanProduct.maxTerm}}">
            </div>

            <div class="row-info-section">
              <glue-container prepend="'max.'" append="'days'">
                <input disabled
                       type="number"
                       ng-model="\$ctrl.loanProduct.maxTerm"/>
              </glue-container>
            </div>
          </td>
        </tr>
        <tr ng-if="\$ctrl.isUIDAmortization()">
          <td class="label">UID amortization number</td>
          <td>
            <input type="number"
                   required
                   ng-disabled="!\$ctrl.isEditModeEnabled()"
                   min="1"
                   max="{{\$ctrl.loan.totalAmortizationNumber}}"
                   ng-model="\$ctrl.loan.uidAmortizationNumber">
          </td>
        </tr>

        <tr ng-if="\$ctrl.isUIDAmortization()">
          <td class="label">UID application</td>
          <td>
            <select
                    ng-model="\$ctrl.loan.uidApplication"
                    ng-options="o.value as o.label for o in \$ctrl.uidApplications"
                    ng-disabled="!\$ctrl.isEditModeEnabled()"
                    required></select>
          </td>
        </tr>

        <tr>
          <td class="label">Date granted</td>
          <td>
            <date-granted date-granted="\$ctrl.loan.grantDate"
                          loan-type-id="\$ctrl.loan.loanTypeId"
                          override="!\$ctrl.shouldOverrideDates()"
                          disabled="!\$ctrl.isEditModeEnabled()">
            </date-granted>
          </td>
        </tr>
        <tr>
          <td class="label">First payment date</td>
          <td>
            <date output-format="local-date"
                  name="firstAmortizationDueDate"
                  ng-required="true"
                  min="\$ctrl.minDate"
                  max="\$ctrl.maxDate"
                  ng-model="\$ctrl.loan.firstAmortizationDueDate"
                  ng-disabled="!\$ctrl.isEditModeEnabled() || \$ctrl.loan.paymentIntervalDefinition.paymentIntervalType === 'SINGLE_PAYMENT'"></date>
            <button type="button" class="btn btn-default" id="simulationBtn"
                    ng-if="!\$ctrl.hideSimulation"
                    ng-disabled="\$ctrl.previewAmortizationDisabled()"
                    ng-click="\$ctrl.previewAmortization()">
              Loan simulation
            </button>
          </td>
        </tr>
        <tr ng-if="\$ctrl.showReleaseDate">
          <td class="label">Release date</td>
          <td>
            <date output-format="local-date"
                  ng-required="false"
                  min="\$ctrl.loan.grantDate"
                  max="\$ctrl.loan.firstAmortizationDueDate"
                  ng-model="\$ctrl.loan.releaseAllowedDate"
                  ng-disabled="!\$ctrl.isEditModeEnabled()"></date>
          </td>
        </tr>
        <tr ng-if="\$ctrl.showRateTypeId">
          <td class="label">Client type</td>
          <td>
            <select
                    ng-required="true"
                    ng-disabled="!\$ctrl.isEditModeEnabled()"
                    ng-model="\$ctrl.loan.loanInformation.loanRateTypeId"
                    ng-options="title.id as title.description for title in \$ctrl.dict.LOAN_RATE_TYPE">
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.loanProduct.depEd && \$ctrl.loanProduct.depEdPolicyNumberStrategy === 'MANUAL'">
          <td class="label">Policy number</td>
          <td>
            <input ng-model="\$ctrl.loan.depEdPolicyNumber"
                   ng-minlength="\$ctrl.depEdPolicyNumberLength"
                   ng-maxlength="\$ctrl.depEdPolicyNumberLength"
                   type="text"
                   ng-disabled="\$ctrl.loan.id"
                   required/>
            <div
              class="policy-number-length-error"
              ng-if="\$ctrl.formParam.\$error.minlength || \$ctrl.formParam.\$error.maxlength">
              Policy number should have {{\$ctrl.depEdPolicyNumberLength}} characters
            </div>
          </td>
        </tr>
        <tr ng-if="\$ctrl.loanProduct.depEd">
          <td class="label">DepEd income source</td>
          <td>
            <select
                    required
                    ng-disabled="\$ctrl.loan.id"
                    ng-model="\$ctrl.loan.depEdIncomeSourceId"
                    ng-options="source.value as source.label for source in \$ctrl.depEdIncomeSources"
            >
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.creditScoringAvailable">
          <td class="label">Credit scoring</td>
          <td>
            <button
              type="button"
              class="btn btn-default"
              ng-disabled="\$ctrl.previewAmortizationDisabled()"
              ng-click="\$ctrl.showCreditScoring()">
              Calculate score
            </button>
            <help
              title="Interest rate, principal amount, payment interval, grant date, amortization number and first payment date are required for credit scoring simulation">
            </help>
          </td>
        </tr>
        </tbody>
      </table>
    <div class="clearfix"></div>
  </div>

  <loan-preview
    loan="\$ctrl.loan.loanPreview"
    loan-type="\$ctrl.loanProduct"
    waive-request="\$ctrl.loan.waiveRequest"></loan-preview>
</form>

<credit-scoring-modal
  on-api-ready="\$ctrl.onCreditScoringModalReady"></credit-scoring-modal>

<ada-auto-configuration-preview
  view="'TARGET'"
  customer-id="\$ctrl.customerId"
  definition-id="\$ctrl.loanProduct.productDefinition.id"
  condition-text="'After loan release'"
>
</ada-auto-configuration-preview>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/new-loan/page/details/parameters/customer-loan-create-parameters.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;